export interface ParsedStompFrame {
  command: string;
  body: string;
}

export function buildStompFrame(command: string, headers: Record<string, string>, body: string = ''): string {
  const headerLines = Object.entries(headers).map(([key, value]) => `${key}:${value}`);
  return `${command}\n${headerLines.join('\n')}\n\n${body}\u0000`;
}

export function parseStompFrame(frame: string): ParsedStompFrame {
  const normalizedFrame = frame.replace(/\r\n/g, '\n');
  const splitIndex = normalizedFrame.indexOf('\n\n');

  if (splitIndex === -1) {
    const [command] = normalizedFrame.split('\n');
    return {
      command: command?.trim() ?? '',
      body: ''
    };
  }

  const headerPart = normalizedFrame.slice(0, splitIndex);
  const body = normalizedFrame.slice(splitIndex + 2).trim();
  const [command] = headerPart.split('\n');

  return {
    command: command?.trim() ?? '',
    body
  };
}
